/* src/app/common/components/side-menu/side-menu.component.scss */
:host {
  display: block;
  height: 100%;
  --ion-background-color: var(--ion-color-primary-tint);
}
.menus-container {
  position: relative;
  top: 6%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
ion-list.side-menu-items {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
ion-list.side-menu-items ion-item {
  --color: #eee;
  --background-focused-opacity: 0.14;
  --background-hover-opacity: 0.08;
  display: flex;
  align-items: center;
  min-height: 40px;
}
ion-list.side-menu-items ion-item ion-icon,
ion-list.side-menu-items ion-item i.bi {
  min-width: 20px;
  margin-right: 15px;
  color: var(--color);
  pointer-events: none;
}
ion-list.side-menu-items ion-item.active {
  --color: var(--ion-color-secondary-shade);
  font-weight: 600;
}
ion-list.side-menu-items ion-item.active ion-icon,
ion-list.side-menu-items ion-item.active i {
  transform: scale(1.1);
}
ion-list.side-menu-items ion-item:hover {
  background: var(--ion-color-tile);
}
ion-list.side-menu-items ion-item:hover ion-item {
  color: #1e1e1e;
}
.spacer {
  flex-grow: 1;
}
@media screen and (min-width: 768px) {
  .menus-container {
    height: auto !important;
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  .menus-container {
    top: 0;
    height: calc(100% - 30px);
  }
  ion-list.side-menu-items ion-item {
    --background-focused-opacity: 0.1;
    --background-hover-opacity: 0.05;
  }
}
.ion-text-capitalize {
  text-transform: capitalize !important;
}
/*# sourceMappingURL=side-menu.component.css.map */
